import * as API from '@vodafoneziggo/sandwich/generic/api';

// Set this config option, so we always bypass the array flattening functionality of the Sandwich API implementation.
API.setDefaultApiConfigOption('getRawData', true);

export default { ...API, delete: API.del };
